$(function() {
    $.each($('[layout-content]'), function(){
        let $p = $(this).children().last()
        if ($p.is('p')) {
            $p.addClass('mb-0')
        }
    })
});